import React, { useEffect, useState } from "react";
import API, { UPDATE_TURN_USER } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, InputNumber, Input, message } from "antd";
import ModalCommon from "../../components/Modal";

const TEXT = {
    username: "Tên đăng nhập",
    turn: "Lượt chơi",
}

const UpdateTurn = () => {
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    const [username, setUsername] = useState();
    const [turns, setTurns] = useState();

    const handleChangeInput = (e, key) => {
        switch (key) {
            case 1: setUsername(e.target.value); return;
            case 2: setTurns(e); return;
            default: return;
        }
    };

    const handleUpdateConfig = async () => {
        setIsShowModalConfirm(false);
        const body = {
            username: username,
            turns: turns
        };

        await API.post(`${UPDATE_TURN_USER}`, body).then((response) => {
            if (response) {
                setIsShowModalSuccess(true);
            }
        }).catch((error) => {
            const errorMessage = error.data?.message || "An error occurred";
            showError(errorMessage);
        });
    };

    const showError = (errorMessage) => {
        messageApi.open({
        type: 'error',
        content: errorMessage,
        });
    };

    const handleShowModal = () => {
        setIsShowModalConfirm(true);
    };

    const renderInput = (key, changeInput, label) => {
        return (
            <div className={`flex w-full items-center ${key !== "vip0_5" ? "mt-4" : ""}`}>
                <div className="flex w-[20%] justify-end mr-10">{label}:</div>
                <div className="w-[60%]">
                    <Input
                        key={key}
                        style={{ width: "100%" }}
                        onChange={changeInput}
                    />
                </div>
            </div>
        )
    }

    const renderInputNumer = (key, changeInput, max, label) => {
        return (
            <div className={`flex w-full items-center ${key !== "vip0_5" ? "mt-4" : ""}`}>
                <div className="flex w-[20%] justify-end mr-10">{label}:</div>
                <div className="w-[60%]">
                    <InputNumber
                        key={key}
                        style={{ width: "100%" }}
                        onChange={changeInput}
                        max={max}
                        min={-10}
                    />
                </div>
            </div>
        )
    }

    return (
        <div className="col-12">
            {contextHolder}
            <div className="col-12">
                <div className="flex w-full">
                    <div className="flex flex-col w-full items-center justify-center">
                        <div className="col-10 mt-2 flex flex-col items-center justify-center">
                            {renderInput(
                                "username",
                                (e) => handleChangeInput(e, 1),
                                `${TEXT.username}`
                            )}

                            {renderInputNumer(
                                "turns",
                                (e) => handleChangeInput(e, 2),
                                1000000000, `${TEXT.turn}`
                            )}
                        </div>
                        <div className="col-10 mt-5 flex items-center justify-center">
                            <Button type="primary" onClick={handleShowModal} disabled={!username || !turns}>
                                Cập nhật
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={'Bạn muốn cập nhật lượt chơi của hội viên?'}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={handleUpdateConfig}
                    close={() => setIsShowModalConfirm(false)}
                />
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={'Cập nhật lượt chơi thành công'}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                    }}
                />
            )}
        </div>
    );
};

export default UpdateTurn;
